import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { KeyResource } from '@app/shared/resources/key.resource';

@Injectable({
  providedIn: 'root'
})
export class KeyService {
  constructor(private keyResource: KeyResource) {}

  isBuildingSecure(id: number): Observable<boolean> {
    return this.keyResource.isBuildingSecure(id);
  }
}
